import React, { useEffect, useState } from "react";
import { WifiOff, CloudUpload } from "lucide-react";
import { getQueue, subscribe, flush } from "@/lib/offlineQueue";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  const [queueLen, setQueueLen] = useState(getQueue().length);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    const unsub = subscribe((q) => setQueueLen(q.length));
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      unsub();
    };
  }, []);

  const doFlush = async () => {
    setSyncing(true);
    try { await flush(); } finally { setSyncing(false); }
  };

  if (online && queueLen === 0) return null;

  return (
    <div
      data-testid="offline-indicator"
      className={`fixed top-14 md:top-3 inset-x-0 mx-auto max-w-[92vw] md:max-w-md z-50 rounded-sm px-3 py-2 text-xs flex items-center justify-between gap-3 shadow-lg ${
        online ? "bg-amber-500/15 border border-amber-500/40 text-amber-700" : "bg-red-500/15 border border-red-500/40 text-red-700"
      }`}
    >
      <div className="flex items-center gap-2 min-w-0">
        {online ? <CloudUpload size={14} strokeWidth={1.8} /> : <WifiOff size={14} strokeWidth={1.8} />}
        <span className="truncate">
          {online
            ? (queueLen > 0 ? `${queueLen} Aktion${queueLen > 1 ? "en" : ""} zu synchronisieren` : "Online")
            : (queueLen > 0 ? `Offline – ${queueLen} Aktion${queueLen > 1 ? "en" : ""} gespeichert` : "Offline – Daten werden lokal gespeichert")}
        </span>
      </div>
      {online && queueLen > 0 && (
        <button
          onClick={doFlush}
          disabled={syncing}
          data-testid="offline-flush-button"
          className="text-[10px] uppercase tracking-wider border border-current px-2 py-1 rounded-sm hover:bg-current/10 disabled:opacity-50"
        >
          {syncing ? "Sync…" : "Jetzt senden"}
        </button>
      )}
    </div>
  );
}
